// Monatliche Zeitachse für die Timeline.
//
// MonthKey: "YYYY-MM" — zwei-stelliger Monat. Sortierbar als String.
// Bounds: Start (1. des Monats 00:00) und Ende (letzter Tag 23:59:59.999),
// totalDays = Anzahl der Tage im Monat.

const MONTHS_BACK = 6;
const MONTHS_FORWARD = 11;

const MONTH_NAMES_DE = ['Jan','Feb','Mär','Apr','Mai','Jun','Jul','Aug','Sep','Okt','Nov','Dez'];

let monthNames: readonly string[] = MONTH_NAMES_DE;

export function setMonthNames(names: readonly string[]): void {
  if (names.length === 12) monthNames = names;
}

const pad2 = (n: number) => String(n).padStart(2, '0');

export function monthKeyOf(d: Date): string {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}`;
}

export function parseMonthKey(k: string): Date {
  const [y, m] = k.split('-').map(Number);
  return new Date(y, m - 1, 1);
}

export function currentMonthKey(): string {
  return monthKeyOf(new Date());
}

// 18 Monate (6 zurück, aktueller, 11 nach vorn).
export function buildMonthKeys(): string[] {
  const today = new Date();
  const start = new Date(today.getFullYear(), today.getMonth() - MONTHS_BACK, 1);
  const out: string[] = [];
  for (let i = 0; i < MONTHS_BACK + 1 + MONTHS_FORWARD; i++) {
    out.push(monthKeyOf(new Date(start.getFullYear(), start.getMonth() + i, 1)));
  }
  return out;
}

export function monthLabel(k: string): string {
  const [y, m] = k.split('-').map(Number);
  return `${monthNames[m - 1]} ${String(y).slice(-2)}`;
}

export type MonthBounds = { start: Date; end: Date; totalDays: number };

export function monthBounds(monthKey: string): MonthBounds {
  const start = parseMonthKey(monthKey);
  // Ende inkl. 23:59:59.999, damit SPs am letzten Tag (z. B. 30.06.)
  // nicht durch TZ-Drift rausfallen.
  const end = new Date(start.getFullYear(), start.getMonth() + 1, 0, 23, 59, 59, 999);
  const totalDays = new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate();
  return { start, end, totalDays };
}

// Klassifikation für Heute-Hervorhebung in der Header-Zeile.
export type MonthPhase = 'past' | 'now' | 'future';

export function monthPhase(mk: string, ref: string = currentMonthKey()): MonthPhase {
  if (mk === ref) return 'now';
  return mk < ref ? 'past' : 'future';
}
